// extracted by mini-css-extract-plugin
export default {"headCell":"header-table_headCell__t9E8L","cell":"header-table_cell__rr2Zc","bodyRow":"header-table_bodyRow__MERzo","caption":"header-table_caption__qoibT"};